import { createAction, props } from '@ngrx/store';
import { LandingPageEntity } from '../../models/landing-page.entities';

//-- AEM Medallion Banner
export const loadAEMMedallionBanner = createAction(
  '[SkyMiles Landing Page/AEM] Load AEM Medallion Banner'
);

export const loadAEMMedallionBannerSuccess = createAction(
  '[SkyMiles Landing Page/AEM] Load Medallion Banner Success',
  props<{ aemMedallionBannerContent: LandingPageEntity }>()
);

export const loadAEMMedallionBannerFailure = createAction(
  '[SkyMiles Landing Page/AEM] Load AEM Landing Page Failure',
  props<{ aemErrorContent: LandingPageEntity }>()
);

//-- AEM Menu
export const loadAEMMenu = createAction(
  '[SkyMiles Landing Page/AEM] Load AEM Menu'
);

export const loadAEMMenuSuccess = createAction(
  '[SkyMiles Landing Page/AEM] Load AEM Menu Success',
  props<{ aemMenuContent: LandingPageEntity }>()
);

export const loadAEMMenuFailure = createAction(
  '[SkyMiles Landing Page/AEM] Load AEM Menu Failure',
  props<{ aemMenuErrorContent: LandingPageEntity }>()
);

//-- AEM Feature Flags
export const loadAEMFeatureFlags = createAction(
  '[SkyMiles Landing Page/AEM] Load AEM Feature Flags'
);

export const loadAEMFeatureFlagsSuccess = createAction(
  '[SkyMiles Landing Page/AEM] Load AEM Feature Flags Success',
  props<{ aemFeatureFlags: LandingPageEntity }>()
);

export const loadAEMFeatureFlagsFailure = createAction(
  '[SkyMiles Landing Page/AEM] Load AEM Feature Flags Failure',
  props<{ aemFeatureFlagsError: LandingPageEntity }>()
);

//-- AEM Error Messages
export const loadAEMErrorMessages = createAction(
  '[SkyMiles Landing Page/AEM] Load AEM Error Messages'
);

export const loadAEMErrorMessagesSuccess = createAction(
  '[SkyMiles Landing Page/AEM] Load AEM Error Messages Success',
  props<{ aemErrorMessages: LandingPageEntity }>()
);

export const loadAEMErrorMessagesFailure = createAction(
  '[SkyMiles Landing Page/AEM] Load AEM Error Messages Failure',
  props<{ aemErrorMessagesError: LandingPageEntity }>()
);

//-- DBT AEM Feature Flag Content
export const loadBusinessTravelerFeatureFlagContent = createAction(
  '[SkyMiles Landing Page/AEM] Load Business Traveler Feature Flag Content'
);

export const loadBusinessTravelerFeatureFlagSuccess = createAction(
  '[SkyMiles Landing Page/AEM] Load Business Traveler Feature Flag Content Success',
  props<{ aemBusinessTravelerFeatureFlag: LandingPageEntity }>()
);

export const loadBusinessTravelerFeatureFlagFailure = createAction(
  '[SkyMiles Landing Page/AEM] Load Business Traveler Feature Flag Content Failure',
  props<{ aemBusinessTravelerFeatureFlagError: LandingPageEntity }>()
);

//-- DBT GraphQL Content
export const loadBusinessTravelerContent = createAction(
  '[SkyMiles Landing Page/GraphQL] Load GraphQL Business Traveler Content'
);

export const loadBusinessTravelerContentSuccess = createAction(
  '[SkyMiles Landing Page/GraphQL] Load GraphQL Business Traveler Content Success',
  props<{ businessTraveler: LandingPageEntity }>()
);

export const loadBusinessTravelerContentFailure = createAction(
  '[SkyMiles Landing Page/GraphQL] Load GraphQL Business Traveler Content Failure',
  props<{ businessTravelerError: LandingPageEntity }>()
);
